import styled from "styled-components";

export const StyledNavBar = styled.div`
  .top-nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 91;
    display: grid;
    grid-template-columns: minmax(180px, 1fr) auto minmax(180px, 1fr);
    align-items: center;
    min-height: 88px;
    padding: 0 18px;
    border-bottom: 1px solid
      ${({ $isMobileSidebarOpen }) =>
        $isMobileSidebarOpen ? "transparent" : "rgba(89, 244, 119, 0.1)"};
    background: rgba(14, 32, 41, 0.96);
    box-shadow: ${({ $isMobileSidebarOpen }) =>
      $isMobileSidebarOpen ? "none" : "0 10px 22px rgba(0, 0, 0, 0.28)"};
    backdrop-filter: blur(12px);
    transition: border-color 180ms ease, box-shadow 180ms ease;
  }

  .nav-left,
  .nav-right,
  .nav-member-actions,
  .nav-auth-actions,
  .nav-center-wallet {
    display: flex;
    align-items: center;
  }

  .nav-left {
    grid-column: 1;
    min-width: 0;
    justify-content: flex-start;
  }

  .nav-right {
    grid-column: 3;
    justify-self: end;
    min-width: 0;
    justify-content: flex-end;
    gap: 10px;
  }

  .nav-public-actions {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .brand-link {
    display: inline-flex;
    align-items: center;
    min-width: 0;
    height: 74px;
  }

  .brand-logo {
    width: auto;
    max-width: min(340px, 20vw);
    max-height: 74px;
    object-fit: contain;
  }

  .brand-logo.backend-logo {
    filter: none;
  }

  .brand-logo-skeleton {
    width: 132px;
    height: 34px;
    border-radius: 8px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.06),
      rgba(255, 255, 255, 0.13),
      rgba(255, 255, 255, 0.06)
    );
    background-size: 220% 100%;
    animation: cryptoSkeletonShimmer 1.35s ease-in-out infinite;
  }

  .nav-auth-actions {
    gap: 8px;
  }

  .nav-member-actions {
    gap: 8px;
  }

  .header-search-button {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 40px !important;
    min-width: 40px !important;
    height: 40px !important;
    margin: 0 !important;
    border: 0 !important;
    border-radius: 8px !important;
    padding: 0 !important;
    color: #b1b6c6 !important;
    background: rgba(166, 196, 213, 0.08) !important;
    box-shadow: none !important;
    cursor: pointer;
    transition: background 0.14s ease, color 0.14s ease;
  }

  .header-search-button:hover {
    color: #f4f7fb !important;
    background: rgba(166, 196, 213, 0.13) !important;
  }

  .header-search-button svg {
    width: 17px;
    height: 17px;
  }

  .header-search-button svg path {
    fill: currentColor;
    stroke: none;
  }

  .nav-center-wallet {
    grid-column: 2;
    justify-self: center;
    height: 46px;
    overflow: visible;
    border-radius: 12px;
    background: var(--crypto-surface-3);
    box-shadow:
      0 14px 26px rgba(0, 0, 0, 0.26),
      inset 0 1px 0 rgba(255, 255, 255, 0.04);
  }

  .total-money-container {
    position: relative;
    display: inline-flex;
    align-items: center;
    height: 100%;
    color: #f7fbff;
  }

  .total-money-trigger {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    min-width: 224px;
    height: 100%;
    border: 0;
    border-radius: 12px 0 0 12px;
    padding: 0 17px 0 21px;
    color: #f7fbff;
    background: transparent;
    cursor: pointer;
    transition: background 0.15s ease;
  }

  .total-money-trigger:hover,
  .total-money-trigger[aria-expanded="true"] {
    background: rgba(255, 255, 255, 0.025);
  }

  .total-money-amount {
    min-width: 0;
    max-width: 190px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 17px;
    line-height: 1;
    font-weight: 700;
    letter-spacing: 0;
  }

  .total-money-unit {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    color: #a9b7c8;
    font-size: 12px;
    line-height: 1;
    font-weight: 700;
  }

  .total-money-chevron {
    display: inline-flex;
    align-items: center;
    color: #dce7ef;
  }

  .total-money-chevron svg {
    width: 12px;
    height: 8px;
  }

  .total-money-chevron path {
    fill: none;
    stroke: currentColor;
    stroke-width: 2.3;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .wallet-balance-dropdown {
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    z-index: 94;
    width: 264px;
    border: 1px solid rgba(89, 244, 119, 0.16);
    border-radius: 12px;
    padding: 8px;
    background: rgba(13, 31, 40, 0.98);
    box-shadow:
      0 18px 32px rgba(0, 0, 0, 0.36),
      inset 0 1px 0 rgba(255, 255, 255, 0.04);
    backdrop-filter: blur(12px);
  }

  .wallet-balance-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    min-height: 36px;
    border-radius: 8px;
    padding: 0 10px;
  }

  .wallet-balance-row + .wallet-balance-row {
    margin-top: 3px;
  }

  .wallet-balance-row:hover {
    background: rgba(89, 244, 119, 0.06);
  }

  .wallet-balance-label {
    color: #98a6b8;
    font-size: 12px;
    line-height: 1;
    font-weight: 700;
  }

  .wallet-balance-value {
    color: #f5f8fc;
    font-size: 13px;
    line-height: 1;
    font-weight: 800;
    white-space: nowrap;
  }

  .wallet-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 46px;
    min-width: 84px;
    border: 0;
    border-left: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 0 12px 12px 0;
    padding: 0 24px;
    color: #101722;
    background: linear-gradient(135deg, #5dff85, #22d65e);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.32);
    font-size: 16px;
    line-height: 1;
    font-weight: 800;
    cursor: pointer;
    transition: filter 0.16s ease;
  }

  .wallet-button:hover {
    filter: brightness(1.04);
  }

  .nav-icon-button {
    position: relative;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 40px !important;
    min-width: 40px !important;
    height: 40px !important;
    margin: 0 !important;
    border: 0 !important;
    border-radius: 8px !important;
    padding: 0 !important;
    color: #f4f7fb !important;
    background: transparent !important;
    cursor: pointer;
    transition: background 0.16s ease, color 0.16s ease, transform 0.16s ease;
  }

  .nav-icon-button:hover {
    color: var(--crypto-green) !important;
    background: rgba(89, 244, 119, 0.08) !important;
    transform: translateY(-1px);
  }

  .nav-icon-button svg {
    width: 23px;
    height: 23px;
  }

  .nav-icon-button svg circle,
  .nav-icon-button svg path {
    fill: none;
    stroke: currentColor;
    stroke-width: 2.25;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .member-search-button svg {
    width: 21px;
    height: 21px;
  }

  .member-search-button svg path {
    fill: currentColor;
    stroke: none;
  }

  .nav-badge {
    position: absolute;
    top: 5px;
    right: 4px;
    min-width: 16px;
    height: 16px;
    border-radius: 999px;
    padding: 0 4px;
    color: #101722;
    background: var(--crypto-green);
    box-shadow: 0 0 10px rgba(89, 244, 119, 0.42);
    font-size: 10px;
    line-height: 16px;
    font-weight: 900;
  }

  @keyframes cryptoSkeletonShimmer {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: -120% 0;
    }
  }

  @media (max-width: 1023px) {
    .top-nav {
      grid-template-columns: 1fr auto;
      min-height: 58px;
      padding: 0 12px;
    }

    .brand-link {
      height: 48px;
    }

    .nav-right {
      grid-column: 2;
    }

    .nav-center-wallet {
      display: none;
    }

    .brand-logo {
      max-width: 180px;
      max-height: 40px;
    }

    .nav-auth-actions {
      gap: 6px;
    }

    .nav-public-actions {
      gap: 8px;
    }

    .nav-auth-actions .auth-header-button {
      height: 36px;
      padding: 0 12px;
      font-size: 12px;
    }
  }

  @media (max-width: 575px) {
    .nav-auth-actions .auth-header-anonymous {
      display: none !important;
    }

    .brand-logo {
      max-width: min(180px, 42vw);
    }

    .nav-icon-button {
      width: 36px !important;
      min-width: 36px !important;
      height: 36px !important;
    }
  }
`;
